var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "h4",
        { style: { margin: "0 0 20px 20px" } },
        [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showReturnBtn,
                  expression: "showReturnBtn",
                },
              ],
              attrs: { type: "primary" },
              on: { click: _vm.handleReturn },
            },
            [_vm._v("返回上级")]
          ),
        ],
        1
      ),
      _c(
        "v-chart",
        {
          attrs: {
            "force-fit": true,
            height: _vm.height,
            padding: [40, 40, "auto", 40],
            data: _vm.data,
            onClick: _vm.handleClick,
          },
        },
        [
          _c("v-tooltip"),
          _c("v-axis"),
          _c("v-legend", { staticClass: "viser-legend" }),
          _c("v-line", { attrs: { position: "type*y", color: "x" } }),
          _c("v-point", {
            attrs: {
              position: "type*y",
              color: "x",
              size: 4,
              "v-style": _vm.style,
              shape: "circle",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }